import React from 'react';

import RecordsScreen from '/component/layout/RecordsScreen';
import {COACH_REPORT} from '/enum/popover.enum';
import {REPORT_CARD_ELIGIBLE_FOR_INCENTIVE_TRIP} from '/enum/reportCard.enum';
import {withTranslation} from '/provider/TranslationProvider';
import {withHOC} from '/util/hoc.util';

import {ReportProps} from '../Report.types';
import withRecordPopover from '../withRecordPopover';

import {EligibleForIncentiveTripContent} from './EligibleForIncentiveTripContent';
import reportPayload from './reportPayload';

export const EligibleForIncentiveTripReport = ({
  loadingData = {total: 0},
  tt = (key: string, defaultValue?: string) => defaultValue || '',
  showRecordPopover = () => {},
}: ReportProps) => {
  return (
    <RecordsScreen
      {...reportPayload}
      // @ts-expect-error TS(2322): Type '{ title: any; description: any; contentProps... Remove this comment to see the full error message
      title={tt('title', 'Eligible for Incentive Trip 2024')}
      description={tt(
        'description',
        'These Coaches are currently eligible for the Incentive Trip 2024. Help encourage them to complete the requirements to qualify.',
      )}
      contentProps={{loadingData, showRecordPopover}}
      contentComponent={EligibleForIncentiveTripContent}
    />
  );
};

export default withHOC(
  withTranslation('report.eligibleForIncentiveTripReport'),
  withRecordPopover({
    reportPayload,
    popoverName: COACH_REPORT,
    popoverContentName: REPORT_CARD_ELIGIBLE_FOR_INCENTIVE_TRIP,
    popoverContentProps: {},
  }),
)(EligibleForIncentiveTripReport);
